import React from "react";
import "../../styles/Offerings/WhyChooseLovenCoders.css";

const WhyChooseLovenCoders = ({ whyData }) => {
  const { title, description, whyOptions } = whyData;
  return (
    <div className="why-container">
      <div className="why-innercontainer">
        <div>
          <div className="why-title">{title}</div>
          <div className="why-desc">{description}</div>
        </div>
        <div className="why-options-container">
          {whyOptions?.map((option, index) => (
            <React.Fragment key={index}>
              <div className="why-option">
                <div className="why-option-title">{option?.title}</div>
                <div className="why-option-desc">{option?.description}</div>
              </div>
              {index !== whyOptions.length - 1 && (
                <hr className="why-custom-hr" />
              )}
            </React.Fragment>
          ))}
          {/* EXAMPLE HERE */}
          {/* <div className="why-option">
            <div className="why-option-title">
              Tailored Solutions For Every Stage
            </div>
            <div className="why-option-desc">
              Whether you're at the Idea, Valley, or Growth stage, we provide
              expert guidance to help you succeed.
            </div>
          </div>
          <hr className="why-custom-hr" /> */}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseLovenCoders;
